export default __webpack_public_path__ + "static/media/buttonbg.c92f1fb4.svg";